module.exports = __webpack_public_path__ + "static/media/called.5616fac3.png";